import { useAct } from 'FlowTaker/store'
import ShareForm from 'FlowBuilder/components/ActionViews/Share/ShareForm'
import TemplateRender from 'FlowBuilder/components/ActionViews/TemplateRender'
import useRenderContext from 'FlowTaker/hooks/useRenderContext'
import useLanguage, { useDefaultFlowLanguage } from 'FlowBuilder/hooks/useLanguageFlow'

export default function ShareAction({ actionId, surveyId }) {
  const act = useAct()
  const bodyHtml = useSel(s => s.taker.flow.template.body)
  const publicUrl = useSel(s => s.taker.flow.publicUrl)
  const context = useRenderContext({ actionId })
  const action = useSel(s => s.taker.flow.actions.find(a => a.id === actionId) || {})
  const language = useLanguage()
  const defaultLanguage = useDefaultFlowLanguage()

  const languagePublicUrl = useMemo(() => defaultLanguage == language ? publicUrl : `${publicUrl}?lang=${language}`, [language, publicUrl, defaultLanguage])

  const handleSubmit = () => {
    return act.taker.completeAction({ actionId })
  }

  const componentMap = useMemo(() => ({
    TakeSurveyForm: <>
      <ShareForm
        action={action}
        onSubmit={handleSubmit}
        onShare={(shareChannel) => act.taker.reportShare({ actionId, shareChannel })}
        publicUrl={languagePublicUrl}
      />
    </>,
  }), [surveyId])

  return <div>
    <TemplateRender htmlContent={bodyHtml} componentMap={componentMap} context={context} />
  </div>
}
